/* istanbul ignore file */
export const track = (opts) => {
  // opts - { component, eventName, primaryCategory, section, target }
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('thd-sharebelt.click', opts);
  }
};
